module.exports = __webpack_public_path__ + "img/40_38_027_040.a10447b0.jpg";